import VueGoogleMaps from '@fawmi/vue-google-maps';
import { defineNuxtPlugin, useRuntimeConfig } from '#app';

export default defineNuxtPlugin(nuxtApp => {
  const config = useRuntimeConfig();
  nuxtApp.vueApp.use(VueGoogleMaps, {
    load: {
      key: config.public.googleMapApiKey
    }
  });
});
